import { Experiment } from "../types";

export const parseExperiment = (experimentAttr: string): Experiment | null => {
  if (!experimentAttr) {
    return null;
  }

  const [name, version] = experimentAttr.split("|");

  if (!name || !version) {
    return null;
  }

  return { name, version };
};
